module.exports = __webpack_public_path__ + "static/gallery_peak_5-db2fbc1ccb10b92991fbcf7a7999c184.jpg";